/* THAYA · theme.js — cart drawer, AJAX cart, free-ship bar, toast */
(function () {
  var CFG = window.THAYA || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = CFG.money_format || '${{amount}}';
    var val = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, val.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
      .replace(/<[^>]+>/g, '');
  }

  /* ---------- toast ---------- */
  var toastEl = $('#thayaToast');
  window.ThayaToast = function (msg) {
    if (!toastEl) return;
    toastEl.innerHTML = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2200);
  };

  /* ---------- drawer ---------- */
  var drawer = $('#thayaDrawer'), scrim = $('#thayaScrim');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); } if (scrim) scrim.classList.add('is-open'); }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); } if (scrim) scrim.classList.remove('is-open'); }
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- render cart ---------- */
  var body = $('#thayaDrawerBody'), totalEl = $('#thayaDrawerTotal'),
      shipMsg = $('#thayaShipMsg'), shipFill = $('#thayaShipFill');
  var FREE = CFG.free_shipping || 0;

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (totalEl) totalEl.textContent = money(cart.total_price);

    if (shipMsg && FREE > 0) {
      var left = Math.max(0, FREE - cart.total_price);
      shipMsg.innerHTML = left > 0
        ? (CFG.strings && CFG.strings.ship_left ? CFG.strings.ship_left.replace('%AMT%', money(left)) : "You're " + money(left) + ' away from a free gift wrap')
        : (CFG.strings && CFG.strings.ship_done ? CFG.strings.ship_done : 'Gift wrap unlocked 🎀');
      if (shipFill) shipFill.style.width = Math.min(100, cart.total_price / FREE * 100) + '%';
    }

    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="t-drawer__empty">' + (body.dataset.empty || '') + '</div>';
      var ub = document.getElementById('thayaUpsell');
      if (ub) { ub.hidden = true; ub.innerHTML = ''; ub.dataset.for = ''; }
      return;
    }
    body.innerHTML = cart.items.map(function (i) {
      var props = '';
      if (i.properties) {
        Object.keys(i.properties).forEach(function (k) {
          if (k.charAt(0) !== '_' && i.properties[k]) props += k + ': ' + i.properties[k] + ' ';
        });
      }
      var sub = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      return '<div class="t-line-item">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<div><div class="n">' + i.product_title + '</div>' +
        '<div class="v">' + (sub || '') + ' × ' + i.quantity + '</div>' +
        (props ? '<div class="v t-line-props">' + props.trim() + '</div>' : '') +
        '<button class="t-line-remove" data-remove="' + i.key + '">' + (CFG.strings && CFG.strings.remove || 'Remove') + '</button></div>' +
        '<div class="p">' + money(i.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    $$('[data-remove]', body).forEach(function (b) {
      b.addEventListener('click', function () { changeQty(b.dataset.remove, 0); });
    });
    renderUpsell(cart);
  }

  /* ---------- cart cross-sell (Completes the look) ---------- */

  /* Colour families for a title, using the same word lists as snippets/pair-colours.liquid.
     Neutrals match nothing and fall back to the two neutral families. */
  function pairFamilies(title) {
    var P = window.THAYA_PAIRS;
    if (!P || !P.keywords) return [];
    var hay = String(title || '').toLowerCase();
    var out = [];
    Object.keys(P.keywords).forEach(function (fam) {
      if (P.keywords[fam].some(function (w) { return hay.indexOf(w) !== -1; })) out.push(fam);
    });
    return out.length ? out : ['black', 'white'];
  }

  /* Best colour-matched counterpart for what's in the bag: a linen set when the bag holds
     abayas, one of that set's curated abayas when it holds a set. Null if nothing fits —
     the caller then falls back to Shopify's related-products recommendations. */
  function pairPick(cart, inCartHandles) {
    var P = window.THAYA_PAIRS;
    if (!P || !P.sets || !P.sets.length) return null;
    var setHandles = P.sets.map(function (s) { return s.handle; });

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var handle = item.handle || (item.url || '').split('/products/')[1];
      if (handle) handle = handle.split('?')[0];

      // A set in the bag -> offer one of its curated abayas
      if (handle && setHandles.indexOf(handle) !== -1) {
        var list = (P.curated && P.curated[handle]) || [];
        for (var j = 0; j < list.length; j++) {
          if (!inCartHandles[list[j].handle]) return list[j];
        }
        continue;
      }

      // An abaya in the bag -> offer a colour-matched set
      var fams = pairFamilies(item.product_title || item.title);
      for (var k = 0; k < P.sets.length; k++) {
        var s = P.sets[k];
        if (!s.available || inCartHandles[s.handle]) continue;
        if ((s.families || []).some(function (f) { return fams.indexOf(f) !== -1; })) return s;
      }
    }
    return null;
  }

  function renderUpsell(cart) {
    var box = document.getElementById('thayaUpsell');
    if (!box || CFG.cart_upsell === false || !cart.items.length) { if (box) box.hidden = true; return; }
    var pid = cart.items[0].product_id;
    if (box.dataset.for === String(pid)) return;
    box.dataset.for = String(pid);
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var inCartHandles = {};
    cart.items.forEach(function (i) {
      var h = i.handle || (i.url || '').split('/products/')[1];
      if (h) inCartHandles[h.split('?')[0]] = 1;
    });
    var root = (CFG.routes && CFG.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';

    // Prefer the colour-matched pairing; only fall back to generic recommendations
    var pick = pairPick(cart, inCartHandles);
    if (pick) {
      paintUpsell(box, {
        url: pick.url,
        title: pick.title,
        image: pick.image,
        cents: pick.price,
        variantId: pick.variantId
      });
      return;
    }

    fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var rec = (d.products || []).filter(function (p) { return !inCart[p.id] && p.available; })[0];
        if (!rec) { box.hidden = true; box.innerHTML = ''; return; }
        var v = (rec.variants || []).filter(function (x) { return x.available; })[0] || (rec.variants || [])[0];
        if (!v) { box.hidden = true; return; }
        var raw = String(v.price);
        var cents = raw.indexOf('.') > -1 ? Math.round(parseFloat(raw) * 100) : parseInt(raw, 10);
        var img = rec.featured_image || (rec.images && rec.images[0]) || '';
        paintUpsell(box, {
          url: root + 'products/' + rec.handle,
          title: rec.title,
          image: img,
          cents: cents,
          variantId: v.id
        });
      })
      .catch(function () { box.hidden = true; });
  }

  /* Shared renderer so the colour-matched pick and the recommendations fallback
     produce exactly the same card. */
  function paintUpsell(box, p) {
    var img = p.image || '';
    if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
    box.innerHTML =
      '<div class="t-upsell">' +
      (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
      '<div class="t-upsell__info">' +
      '<div class="t-upsell__label">' + (CFG.strings && CFG.strings.completes || 'Completes the look') + '</div>' +
      '<a class="t-upsell__name" href="' + p.url + '">' + p.title + '</a>' +
      '<div class="t-upsell__price">' + money(p.cents) + '</div></div>' +
      '<button type="button" class="t-upsell__add" data-add-variant="' + p.variantId + '">' + (CFG.strings && CFG.strings.add || 'Add') + '</button>' +
      '</div>';
    box.hidden = false;
    box.querySelectorAll('[data-add-variant]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); window.ThayaCart.addVariant(b.dataset.addVariant, 1); });
    });
  }

  function fetchCart() {
    return fetch(CFG.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeQty(key, qty) {
    return fetch(CFG.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  /* ---------- add to cart ---------- */
  window.ThayaCart = {
    open: openDrawer,
    refresh: fetchCart,
    addFromForm: function (form) {
      var data = new FormData(form);
      // drop empty line-item properties so the order stays clean in the dashboard
      var empties = [];
      data.forEach(function (v, k) { if (k.indexOf('properties[') === 0 && String(v).trim() === '') empties.push(k); });
      empties.forEach(function (k) { data.delete(k); });
      return fetch(CFG.routes.cart_add, { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { window.ThayaToast(res.description || res.message); return; }
          window.ThayaToast(CFG.strings && CFG.strings.added || 'Added to cart');
          var atc = form.querySelector('[data-atc]');
          if (atc) { atc.classList.add('is-added'); setTimeout(function () { atc.classList.remove('is-added'); }, 900); }
          return fetchCart().then(openDrawer);
        });
    },
    addVariant: function (id, qty) {
      return fetch(CFG.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      }).then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { window.ThayaToast(res.description || res.message); return; }
          window.ThayaToast(CFG.strings && CFG.strings.added || 'Added to cart');
          return fetchCart().then(openDrawer);
        });
    }
  };

  /* ---------- quick-add buttons (editorial "shop the look") ---------- */
  $$('[data-add-variant]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (!b.dataset.addVariant) return;
      window.ThayaCart.addVariant(b.dataset.addVariant, 1);
    });
  });

  /* ---------- initial paint ---------- */
  fetchCart();
})();
